import React from 'react';
import { Loader2, ShoppingCart } from 'lucide-react';

const AnalysisEbayResultsSection = ({ ebayLoading, ebayResults }) => {
  if (!ebayLoading && !ebayResults) {
    return null;
  }

  return (
    <div className="mt-4 sm:mt-6 border-t border-hairline pt-4">
      <div className="flex items-center gap-2 mb-3">
        <ShoppingCart size={18} className="text-muted" />
        <h4 className="text-base sm:text-lg font-medium text-muted">Similar Items on eBay</h4>
        {ebayLoading && <Loader2 size={16} className="animate-spin text-accent" />}
      </div>

      {ebayLoading && !ebayResults && (
        <p className="text-sm text-muted italic">Searching eBay for similar items...</p>
      )}
      {ebayResults && ebayResults.length === 0 && (
        <p className="text-sm text-muted italic">No similar items found on eBay.</p>
      )}
      {ebayResults && ebayResults.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {ebayResults.map((ebayItem, idx) => (
            <a
              key={ebayItem.itemId || idx}
              href={ebayItem.itemWebUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="block bg-surface border border-hairline rounded-lg overflow-hidden hover:shadow-md hover:border-accent transition-all group"
            >
              {ebayItem.image && (
                <div className="aspect-[8/7] bg-surface-2 overflow-hidden">
                  <img src={ebayItem.image} alt={ebayItem.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform" />
                </div>
              )}
              <div className="p-2">
                <p className="text-xs font-normal text-ink line-clamp-2 mb-1">{ebayItem.title}</p>
                <p className="text-sm font-normal text-positive leading-5">${ebayItem.price} {ebayItem.currency}</p>
                {ebayItem.condition && (
                  <p className="text-[10px] text-ink mt-0.5">{ebayItem.condition}</p>
                )}
              </div>
            </a>
          ))}
        </div>
      )}
    </div>
  );
};

export default AnalysisEbayResultsSection;
